import type { TrackingLabels } from "../tracking/TrackingLabels";
import { HeurekaElementFactory } from "../util/HeurekaElementFactory";
import { events } from "../events";
import { PopularFacetRanges } from "./PopularFacetRanges";
import { forEachElement } from "../util/Utils";
import { readLegacyLabel, updateLegacyLabel } from "../tracking/FeatureTracking";
import { Filter } from "./Filter";
import tracker from "../tracking/Tracker";
import {
  filterSheetButton,
  menuBarButtonForm,
  ocSheetContent,
  quickFilterButton,
  sheetContent,
} from "../filtersheet/Selectors";
import { SvelteFacet } from "./SvelteFacet";

const POPULAR_FACET_VALUES_WRAPPER_CLASS = "hc_facetValueGroup--unselectedPopular";
const FACET_VALUE_TAG_FORM_SELECTOR = ".find_facetValueTags form";

export class SveltePopularFacetValuesWrapper {
  static readonly factory: HeurekaElementFactory<SveltePopularFacetValuesWrapper, keyof HTMLElementTagNameMap> =
    HeurekaElementFactory.byClass(POPULAR_FACET_VALUES_WRAPPER_CLASS, SveltePopularFacetValuesWrapper);

  /*               */
  constructor(readonly popularFacetValuesWrapper: HTMLElement) {}

  public initialize() {
    this.facet.filter?.toggleInlineMode(true);
    return this;
  }

  get facet() {
    return SvelteFacet.factory.closest(this.popularFacetValuesWrapper);
  }

  get sanPopularFacetValues(): TrackingLabels["san_PopularFacetValues"] | undefined {
    const facet = this.facet;
    if (facet && !facet.facet.hidden) {
      return facet.facet.name;
    }
  }
}

function onFilterSectionLoaded() {
  SveltePopularFacetValuesWrapper.factory.all().forEach((wrapper) => wrapper.initialize());

  const rangeChipFacetIds = SvelteFacet.ranges()
    /*                                            */
    .filter((facet) => facet.allFacetValues.length > 0)
    .map((facet) => facet.name);

  const sveltePopularFacetValuesWrappers: SveltePopularFacetValuesWrapper[] =
    SveltePopularFacetValuesWrapper.factory.all();
  const sveltePopularFacetIds = sveltePopularFacetValuesWrappers
    .map((wrapper) => wrapper.sanPopularFacetValues)
    .filter((facetId) => !!facetId);

  const popularRanges: PopularFacetRanges[] = PopularFacetRanges.factory.all();
  const popularRangesFacetIds = popularRanges
    .map((wrapper) => wrapper.sanPopularFacetValues)
    .filter((facetId) => !!facetId);
  const joinedFacetIds = [...sveltePopularFacetIds, ...rangeChipFacetIds, ...popularRangesFacetIds].sort().join("|");

  Filter.factory.forEach((filter) => {
    filter.sanPopularFacetValues = joinedFacetIds;
  });

  popularFacetValuesTracking();
}

function popularFacetValuesTracking() {
  const san_PopularFacetValues = readSanPopularFacetValues();
  tracker.addToPageImpression({
    san_PopularFacetValues: san_PopularFacetValues,
  });
  updateSanPopularFacetValues(filterSheetButton(), san_PopularFacetValues);
  updateSanPopularFacetValues(quickFilterButton(), san_PopularFacetValues);
  updateSanPopularFacetValues(menuBarButtonForm(), san_PopularFacetValues);
  updateSanPopularFacetValues(sheetContent(), san_PopularFacetValues);
  updateSanPopularFacetValues(ocSheetContent(), san_PopularFacetValues);
  forEachElement(FACET_VALUE_TAG_FORM_SELECTOR, (elem) => updateSanPopularFacetValues(elem, san_PopularFacetValues));
}

export function updateSanPopularFacetValues(
  element: HTMLElement | null,
  san_PopularFacetValues: TrackingLabels["san_PopularFacetValues"],
) {
  if (element) {
    updateLegacyLabel(element, "san_PopularFacetValues", san_PopularFacetValues);
  }
}

export function readSanPopularFacetValues(): TrackingLabels["san_PopularFacetValues"] {
  /*                                               */
  const filterForm = SveltePopularFacetValuesWrapper.factory.pick()?.facet?.filter?.form;
  return (filterForm && readLegacyLabel(filterForm, "san_PopularFacetValues")) || "none";
}

export function registerSveltePopularFacetValuesListeners() {
  events.onFilterSectionLoaded(onFilterSectionLoaded);
}
